(function ($) {

    $(document).ready(function () {
        $(".collapse-event a").click(function (e) {
            e.preventDefault();
            if ($(this).text() == "Expand all Events") {
                $(this).text("Collapse All Events")
            } else {
                $(this).text("Expand all Events")
            }
            $(".collapse").toggleClass("rotate-arrow");
            $(".collapse .text-wrap").stop(true, true).slideToggle(500);
        });
        $(".collapse-btn").on("click", function (e) {
            e.preventDefault();
            var windowWidth = $(window).width();
                if ($(this).parent().hasClass('rotate-arrow')) {
                    $(this).parent().removeClass('rotate-arrow');
                    $(this).parent().find(".text-wrap").stop(true, true).slideUp(500);
                }
                else {
                    // Hide the other panels
                    $(this).parent().addClass('rotate-arrow');
                    $(this).parent().find(".text-wrap").stop(true, true).slideDown(500);
                }
        });
    });

})(jQuery);